<template>
  <div class="whole">
    <div class="org_msg" flexContainer>
      <div class="message" flex-1 flexContainer_c>
        <div class="text">组织信息</div>
        <div class="msg" flex-1 flexContainer>
          <div class="icon">
            <img :src="msg_obj.logo" alt="暂无图片" />
          </div>
          <div class="simple" flex-1 flexContainer_c>
            <div class="name">{{msg_obj.name}}</div>
            <div class="phone" flex-1 flexContainer>
              <div class="left" flex-1 flexContainer_c>
                <div>负 责 人 ：{{msg_obj.createUserName}}</div>
                <div>组织规模：{{msg_obj.scale}}</div>
                <!-- <div>组织人数：{{msg_obj.scale}}人</div> -->
                <div v-show="msg_obj.source ==0">创建平台：未知</div>
                <div v-show="msg_obj.source ==1">创建平台：担当</div>
                <div v-show="msg_obj.source ==2">创建平台：云盘</div>
                <div v-show="msg_obj.source ==3">创建平台：云资产</div>
              </div>
              <div class="right" flex-1 flexContainer_c>
                <div>手机号 ：{{msg_obj.mobile}}</div>
                <div>创建时间：{{msg_obj.createTime | formateTitle}}</div>
                <div>组织地点：{{msg_obj.area}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="function">
        <div class="text">启用功能</div>
        <div class="block_p" flexContainer>
          <div class="block">
            <img :src="task_msg" />
          </div>
          <div class="block">
            <img :src="task_time" />
          </div>
          <div class="block" style="margin-right:0px">
            <img :src="task_check" />
          </div>
          <div class="block">
            <img :src="task_pan" />
          </div>
          <div class="block">
            <img :src="task_asset" />
          </div>
        </div>
      </div>
    </div>
    <div class="org_con" :style="{height:detail_height+'px'}" v-show="isConstructor">
      <div class="text">组织架构</div>
      <el-container :style="{height:detail_height -63+'px'}" style="border: 1px solid #eee">
        <el-aside width="200px">
          <el-tree
            :data="org_tree"
            :props="defaultProps"
            node-key="deptId"
            :default-expanded-keys="['0']"
            :default-checked-keys="['0']"
            accordion
            @node-click="handleNodeClick"
          ></el-tree>
        </el-aside>
        <el-main style="height:100%;background-color: #fff">
          <el-table
            :data="staffs"
            height="100%"
            :header-cell-style="headerClass"
            :row-class-name="class_name"
          >
            <el-table-column type="index" label="编号" width="80"></el-table-column>
            <el-table-column prop="name" label="姓名" width="120"></el-table-column>
            <el-table-column label="部门" width="160">
              <template slot-scope="scope">
                <el-popover
                  ref="popover"
                  placement="top"
                  width="200"
                  trigger="hover"
                  :content="scope.row.deptName"
                >
                  <span slot="reference" class="org_name_show">{{scope.row.deptName}}</span>
                </el-popover>
              </template>
            </el-table-column>
            <el-table-column prop="positionName" label="职务" width="140"></el-table-column>
            <el-table-column prop="mobile" label="手机号" width="140"></el-table-column>
            <el-table-column prop="device_model" label="机型" width="120"></el-table-column>
            <el-table-column prop="createTime" label="注册时间" width="200"></el-table-column>
            <el-table-column prop="address" label="操作" width="100">
              <template slot-scope="scope">
                <span class="show_detail" @click="go_detail(scope.row)">详情</span>
              </template>
            </el-table-column>
          </el-table>
          <detail ref="detail_ref"></detail>
        </el-main>
      </el-container>
    </div>
  </div>
</template>
<script>
import { org_tree, org_Info } from "@/api/orgnazition";
import { mapState } from "vuex";
export default {
  components: {
    detail: () =>
      import(/* webpackChunkName: "design" */ "../userTable/components/detail")
  },
  props: { msg_obj: Object },
  data() {
    return {
      org_tree: [],
      staffs: [],
      defaultProps: {
        children: "deptList",
        label: "deptName"
      },
      isConstructor: true, //有无组织架构权限
      detail_height: document.documentElement.clientHeight - 350 || "",
      timers: false,
      task_msg: require("@/assets/Jimage/ddbes_t.png"),
      task_time: require("@/assets/Jimage/ddbes_time.png"),
      task_check: require("@/assets/Jimage/ddbes_check.png"),
      task_pan: require("@/assets/Jimage/ddbes_pan.png"),
      task_asset: require("@/assets/Jimage/ddbes_asset.png")
    };
  },
  computed: mapState(["com_id"]),
  methods: {
    handleNodeClick(data) {
      var all = this.findAll(data);
      this.staffs = all;
    },
    //递归部门
    findAll(data = null) {
      let ls = [];
      if (data) {
        if (data.allMembers.length) {
          ls.push(...data.allMembers);
        }
        if (data.deptList.length) {
          for (let i = 0, len = data.deptList.length; i < len; i++) {
            ls.push(...this.findAll(data.deptList[i]));
          }
        }
      }
      return ls;
    },
    //获取部门人员
    get_staffs() {
      let data = {
        companyId: this.com_id
      };
      org_Info(data)
        .then(res => {
          this.org_tree = [res.data];
          this.staffs = res.data.allMembers;
        })
        .catch(error => {});
    },
    //用户详情
    go_detail(row) {
      this.$refs.detail_ref.init(row);
    },
    headerClass() {
      return "background-color:#FAFCFF;height:33px;padding:5px";
    },
    class_name({ row, rowIndex }) {
      if (rowIndex % 2 === 0) {
        return "popularLine";
      } else {
        return "colorLine";
      }
    }
  },
  mounted() {
    const that = this;
    window.onresize = () => {
      return (() => {
        window.screenHeight = document.documentElement.clientHeight - 350;
        that.detail_height = window.screenHeight;
      })();
    };
    this.get_staffs();
    
  },
  watch: {
    detail_height(val) {
      if (!this.timers) {
        this.screeHeight = val;
        this.timers = true;
        let that = this;
        setTimeout(function() {
          that.timers = false;
        }, 400);
      }
    }
  }
};
</script>
<style lang="scss" scoped>
@include org_name_show;
.org_con {
  border-radius: 3px;
  margin-top: 14px;
  padding: 14px;
  background-color: $menu-color;
  .show_detail {
    cursor: pointer;
    color: $menu-child;
  }
  .text {
    @include s-c-w(16, $detail_t, 500);
    height: 15px;
    background-color: $menu-color;
    margin-bottom: 14px;
  }
  /deep/.el-main {
    padding: 0px;
  }
}
@include admin;
.el-header {
  background-color: #b3c0d1;
  color: #333;
  line-height: 60px;
}

.el-aside {
  color: #333;
  height: 100%;
  background-color: #fff;
  border-right: 1px solid $border_e;
}
/deep/.el-tree {
  .el-tree-node__content {
    height: 30px !important;
    font-size: 12px !important;
  }
  .el-tree-node:focus > .el-tree-node__content {
    background-color: #eef4fe !important;
    color: #2479ed !important;
  }
}

.whole {
  .org_msg {
    .message {
      @include detail;
      border-radius: 3px;
      .msg {
        padding: 28px 0px 33px 22px;
        .icon {
          width: 128px;
          height: 128px;
          margin-right: 36px;
          img {
            width: 128px;
            height: 128px;
          }
        }
        .simple {
          height: 128px;
          .name {
            @include s-c-w(20, $menu-text, 500);
            line-height: 26px;
          }
          .phone {
            margin-top: 30px;
            .left,
            .right {
              @include s-c-w(16, $text-one, 500);
            }
          }
        }
      }
    }
    .function {
      border-radius: 3px;
      width: 365px;
      height: 232px;
      margin-left: 15px;
      @include detail;
      .block_p {
        margin-top: 7px;
        flex-wrap: wrap;
        .block {
          height: 71px;
          width: 104px;
          margin-right: 11px;
          margin-top: 13px;
          img {
            height: 71px;
            width: 104px;
          }
        }
      }
    }
  }
}
</style>